import { CustomTextField, CustomButton, HeaderFilterBox } from '../../../../common/components';

const DifferimentsFilters = ({
  search,
  onSearchChange,
  onFetch,
  isFetching,
}) => {
  return (
    <HeaderFilterBox>
      <CustomTextField
        label="Contrato"
        placeholder="Ej: 12"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        size="medium"
        sx={{ maxWidth: { xs: '100%', md: 250 }, mr: 1.5, mt: 0 }}
      />
      <CustomButton onClick={onFetch} disabled={isFetching} variant='base'>
        Consultar
      </CustomButton>
    </HeaderFilterBox>
  );
};

export default DifferimentsFilters;
